import { AxiosInstance } from 'axios';
import { ConstantModel, mapConstantDtoToModel } from 'api/dto/Constant.dto';

export class ConstantApi {
  constructor(private api: AxiosInstance) {}

  list(): Promise<ConstantModel> {
    return this.api.get('/api/v1/enums').then((response) => mapConstantDtoToModel(response.data));
  }
}
